import styles from './Title.module.scss'

function Title(props: {children: JSX.Element | JSX.Element[] | string | string[]}) {
  return <div className={styles.base}>{props.children}</div>
}

export default Title
